module.exports = __webpack_public_path__ + "img/galeria-acuariofilia-6.5fad47a5.jpg";